var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between"},[_c('h1',{staticClass:"page-header"},[_vm._v(_vm._s(_vm.$t('homework.pageTitle')))]),_c('ts-breadcrumb',{attrs:{"items":[
        { text: _vm.$t('toHomePage'), href: '/' },
        {
          text: _vm.$t('homework.pageTitle'),
          href: '/homeworks'
        },
        {
          text: _vm.$t('create'),
          active: true
        }
      ]}})],1),(_vm.isStaff)?_c('staff-homework-create'):_vm._e(),(_vm.isTeacher)?_c('teacher-homework'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }